export const required = (message: string) => ({
  required: true,
  message,
});

export const whitespace = (message: string) => ({
  required: true,
  message,
});
